import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Pagination } from "@customTypes/index";
import { PatientNote } from "@customTypes/patientNote";

import { patientNoteQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);
  const pagination: Partial<Pagination> = {
    page: res.data.pagination.page,
    pageSize: res.data.pagination.page_size,
    pageCount: res.data.pagination.page_count,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: Partial<PatientNote>[] = [];

    for (const i in res.data.data) {
      const {
        _id,
        patient_id,
        appointment_id,
        title,
        description,
        type,
        c_id,
        tags,
        created_by,
        created_at,
      } = res.data.data[i];

      newData.push({
        id: _id,
        patientId: patient_id,
        appointmentId: appointment_id,
        title,
        description,
        category: type,
        cId: c_id,
        tags,
        createdBy: created_by,
        createdAt: new Date(created_at),
      });
    }

    // console.log({ newData, pagination });
    return {
      newData,
      pagination,
    };
  }
  return null;
};

interface QueryProps {
  isEnabled?: boolean;
  pagination?: Partial<Pagination>;
  patientId: string;
  appointmentId?: string;
  search?: string;
  category?: string;
  cId?: string;
  tags?: string;
  dateRange: string;
}

export const useGetPatientNotes = ({
  pagination,
  patientId,
  appointmentId,
  category,
  tags,
  dateRange,
  search = "",
  isEnabled = true,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();
  console.log("[useGetPatientNotes HOOK] Received props:", { patientId, appointmentId, isEnabled });

  return useQuery({
    queryKey: patientNoteQKeys.allWithFilters({
      pagination,
      patientId,
      ...(appointmentId && { appointmentId }),
      ...(tags && { tags }),
      ...(category && { category }),
      ...(search && { search }),
      dateRange,
    }),
    queryFn: () => {
      const params = {
        patient_id: patientId,
        ...(appointmentId && { appointment_id: appointmentId }),
        ...(tags && { tags }),
        ...(search && { search }),
        ...(category && { type: category }),
        range: dateRange?.replaceAll("-", "_"),
        ...(pagination && {
          page: pagination.page,
          page_size: pagination.pageSize,
        }),
      };
      console.log("[useGetPatientNotes] API Params:", params);
      return api.get(`notes/`, {
        params,
      });
    },
    select,
    enabled: isEnabled,
    staleTime: 1000 * 60 * 5, // 5 minutes

    onError: (res: any) => {
      console.error("[From Get All Patient Notes]", res);
      handleErrors(res, "query");
    },
  });
};
